//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import './SearchByLeagueOrVenue.css'
import { useNavigate } from 'react-router-dom'
import logo from '../../../images/MurrysvilleSportzone.png'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SearchByLeagueOrVenue = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [loadedTeams, setLoadedTeams] = useState()
	const [loadedVenues, setLoadedVenues] = useState()
	const [error, setError] = useState()

	let selectedLeague, selectedTeam, selectedVenue

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues])

	let leagueArray

	if (loadedLeagues && !isLoading) {
		leagueArray = []
		loadedLeagues.forEach((league) => {
			const leagueDisplay =
				league.leagueName +
				(league.divisionName && ' - ' + league.divisionName + ' DIVISION') +
				' - ' +
				league.session +
				' ' +
				league.year
			leagueArray.push(leagueDisplay)
		})
	}
	//
	//
	//
	//
	//
	//Call backend to get all the current TEAMS for our dropdown
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.currentTeamsArray)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [setLoadedTeams])

	let teamArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			//const teamDisplay = team
			teamArray.push(team)
		})
	}
	//
	//
	//
	//Call backend to get all the current VENUES for our dropdown
	useEffect(() => {
		const sendRequest3 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/venues',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error('error message: ' + responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))

				setLoadedVenues(responseData.allVenues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest3()
	}, [setLoadedVenues])

	let venueArray

	if (loadedVenues && !isLoading) {
		venueArray = []
		loadedVenues.forEach((venue) => {
			//const teamDisplay = team
			venueArray.push(venue.venueName)
		})
	}

	//console.log('loadedTeams: ' + JSON.stringify(loadedTeams))

	let navigate = useNavigate()

	//For handling a search by league request:
	const handleChange = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedLeague = loadedLeagues[selectedValue]
		const leagueId = selectedLeague._id
		navigate(`/league/schedule/${leagueId}`)
	}

	//For handling a search by VENUE request
	const handleChange3 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedVenue = loadedVenues[selectedValue]
		const venueId = selectedVenue._id
		navigate(`/league/${venueId}/schedule`) //< - - - should go to VenueSchedule
	}

	return (
		<div className='schedule-search'>
			<div className='schedule-search__card'>
				<div className='schedule-search__logo-wrapper'>
					<img
						src={logo}
						alt='Murrysville SportZone'
						className='schedule-search__logo'
					/>
				</div>

				<div className='schedule-search__instructions'>
					Search by League or Venue:
				</div>

				<div className='schedule-search__dropdowns'>
					{!isLoading && loadedLeagues && (
						<form
							className='schedule-search__form'
							onSubmit={(event) => event.preventDefault()}
						>
							<select
								className='scheduleselector schedule-search__select'
								onChange={handleChange}
								defaultValue=''
							>
								<option value='' disabled>
									League
								</option>

								{leagueArray.map((league, index) => (
									<option value={index} key={index}>
										{league.toUpperCase()}
									</option>
								))}
							</select>
						</form>
					)}

					{!isLoading && loadedVenues && (
						<form
							className='schedule-search__form'
							onSubmit={(event) => event.preventDefault()}
						>
							<select
								className='scheduleselector schedule-search__select'
								onChange={handleChange3}
								defaultValue=''
							>
								<option value='' disabled>
									Venue
								</option>

								{venueArray.map((venue, index) => (
									<option value={index} key={index}>
										{venue}
									</option>
								))}
							</select>
						</form>
					)}
				</div>
			</div>
		</div>
	)
}

export default SearchByLeagueOrVenue
